require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-leap-motion-workshop.json") })
        }
      }, "path---blog-leap-motion-workshop");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-leap-motion-workshop!./.cache/json/blog-leap-motion-workshop.json
// module id = 940
// module chunks = 231608221292675